import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UserService } from 'app/Shared/Services/user.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { FDID } from '../fdid-info.model';
import { ConfirmationService,MessageService } from 'primeng/api';
import { ConstantService } from 'app/Shared/Services/constant-service';
import {CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { DrawerModule } from 'primeng/drawer';

@Component({
    selector: 'app-add-fdid',
    templateUrl: './add-fdid.component.html',
    styleUrls: ['./add-fdid.component.scss'],
    imports: [TableModule, MatProgressSpinnerModule, AutoCompleteModule, ConfirmDialogModule,
       CommonModule, ButtonModule, MatTooltipModule, DrawerModule, FormsModule, DialogModule, ToastModule]
})
export class AddFDIDComponent implements OnInit, OnDestroy{
  @Input() showSideBar!: boolean;
  @Output() closeSideBar: EventEmitter<boolean> = new EventEmitter<boolean>();
  selectedFdid!: FDID | any;
  show: boolean =  true;
  selectedAccountNumber: any;
  accountNumberList!: any[];
  filteredAccountNumber!: any[];
  sourceIds!: Array<any>;
  FDIDEndReasonList: Array<any>;
  fdidTypeList: any;
  accountTypes: any;
  entityTypes: any;
  roles: any;
  isDisable: boolean = true;
  confirmationMessage!: string;
  isDisableAccountNumber: boolean = false;
  isDisableFDID: boolean = true;
  isDisableSave: boolean = false;
  isDisableReceiveFDID: boolean = false;
  receivedGivenName!: string;
  msgs!: any[];
  constructor(private sharedHttpClientService: SharedHttpClientService,
     private confirmationService: ConfirmationService,
     private messageService: MessageService,
     public constantService: ConstantService,
     private urlService: UrlsService ,
     private userService: UserService) { 

    this.selectedFdid = new FDID();
    this.fdidTypeList = [
      {  fdidType: 'ACCOUNT' },
      {  fdidType: 'RELATIONSHIP' },
      {  fdidType: 'ENTITYID'}      
    ];
    this.FDIDEndReasonList = [
      {  fdidEndReason: 'CORRECTION' },
      {  fdidEndReason: 'ENDED' },
      {  fdidEndReason: 'REPLACED' },
      {  fdidEndReason: 'OTHER' }
    ];
    this.entityTypes = [ 
      {  entityType: 'Legal Entity' },
      {  entityType: 'Natural Person' },
      {  entityType: 'Financial Advisor' }
    ]
    this.roles = [
      { role: 'Account Holder' },
      { role: 'Authorised Trader' },
      { role: 'Other' }
    ];
    this.selectedFdid.catReporterIMID = this.userService.getActiveMPID();
  }

  ngOnInit() {
    this.accountNumberList = this.userService.accountNumbers;
    this.isDisableReceiveFDID = false;
  }

  filterAccountNumber(event:any) {
    this.filteredAccountNumber = this.filterAccount(event.query, this.accountNumberList);
  }
  filterAccount(query:any, accountNumbers: any[]): any[] {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filtered: any[] = [];
    for (let i = 0; i < accountNumbers.length; i++) {
      let accountNumber = accountNumbers[i];
      if (accountNumber.label.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(accountNumber);
      }
    }
    return filtered;
  }
  focusOut(accountNumber:any) {
    
    this.getAccountDetails({label: accountNumber})
  }
  getAccountDetails(accountNumber:any) {

    this.selectedFdid.accountNumber = accountNumber.label.toUpperCase();
   
    this.isDisableAccountNumber = true;
    const accNum = this.selectedFdid.accountNumber.toUpperCase();
    this.sharedHttpClientService.get(
      this.urlService.setAPIURl(
        APIURL.CAT_AccountNumbers + '/'+this.userService.getActiveMPID()+ '/'+ accountNumber.label))
        .subscribe({
          next: (result: any) => {
            if(result.data.length === 0) {
                  this.onCheckConfirm('accountNotPresent');
                  this.isDisableFDID = false;
                  this.isDisable = true;
                  this.selectedFdid = new FDID();
                  this.isDisableReceiveFDID = false;
                } else { 
                  this.isDisable = false;
                  this.isDisableReceiveFDID = true;
                  this.selectedFdid = result.data.length > 0 ? result.data[0] : new FDID();
                  this.selectedFdid.fdid = result.data[0] != undefined ? result.data[0].generatedFDID:null;
                  this.receivedGivenName = this.selectedFdid.givenName;
                  this.selectedFdid.active = true;
                  this.onKeyFieldChanges(this.selectedFdid.fdid);
                }  
                this.selectedFdid.accountNumber = accNum; 
                this.selectedFdid.catReporterIMID = this.userService.getActiveMPID();
          },  
          error: (e) => {
              console.error(e);
          }
        }); 
  }

  onClickClose(boolean:any) {
    this.closeSideBar.emit(boolean);
    this.show = false;
  }
  public onCheckConfirm(label: string) {
    let  key:string | any;
    if (label === 'accountNotPresent') {
      key =  'confirmationDialog';
      this.confirmationMessage = 'Want to add new Account Number?';
    } else if(label === 'userNamePresent') {
      key = 'informationDialog';
    }
    this.confirmationService.confirm({
      message: this.confirmationMessage,
      key: key,
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"fdid-confirm-dialog-button",
      rejectButtonStyleClass:"fdid-confirm-dialog-button",
      accept: () => {
          this.isDisable = false;
          this.isDisableSave = false;
      }, 
      reject: () => {
        this.isDisableFDID = true;
        this.isDisableSave = true;
      }
      
     
  });
  this.msgs = [];
  }
  generateFDID() {
    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAT_GenerateFDID
        ), {
          "accountNumber": this.selectedFdid.accountNumber,
          "givenName": this.selectedFdid.givenName
        })
      .subscribe({
        next: (data: any) => {
          this.selectedFdid.fdid = data.generatedFDID;
          this.onKeyFieldChanges(this.selectedFdid.fdid);
          this.isDisableReceiveFDID = true;
        },
        error: (e) => {
            console.error(e);
        }
      });
  }

  onClickReset() {
    this.selectedFdid = new FDID();
    this.selectedFdid.catReporterIMID = this.userService.getActiveMPID();
    this.isDisableAccountNumber = false;
    this.selectedAccountNumber = "";
    this.isDisable = false;
    this.isDisableReceiveFDID = false;
  }
  onClickSave(addFdidForm:NgForm) {
    if(addFdidForm.invalid){
      addFdidForm.form.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Please fill all required fields correctly'
      });
      return;
    }
    else{
    this.selectedFdid.updatedUser = this.userService.userFirstName;
    this.selectedFdid.createdUser = this.userService.userFirstName;
    if(this.selectedFdid.receivedFdid != undefined && this.selectedFdid.receivedFdid.trim.length>0)
    {
      this.selectedFdid.fdid = this.selectedFdid.receivedFdid;
    }
    this.selectedFdid.createdUser = this.userService.userFirstName;
    this.selectedFdid.catReporterIMID = this.userService.getActiveMPID();

    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAT_AddFdid
        ), this.selectedFdid)        
        .subscribe({
          next: (data: any) => {
            this.accountNumberList = this.userService.getAccountNumbers(); 
            this.confirmationMessage = data.msg
            if(data.status) {
              this.messageService.add({ severity: 'success', summary: 'Update Success Message', detail: 'Record Added Successfully' });
              this.closeSideBar.emit(true);
            } else {
              this.onCheckConfirm('userNamePresent');
            }
          },  
          error: (e) => {
              console.error(e);
          }
        });  
      }
  }

  copyReceivedFdid(event: any)
  {
    this.selectedFdid.fdid = this.selectedFdid.receivedFdid;
  }

  onKeyFieldChanges(value:any) {
    if (value) {
      this.selectedFdid.receivedFdid = value;
    }
  }
  
  ngOnDestroy() {
    
  }
}
